import { render, staticRenderFns } from "./online-portal-login-header.vue?vue&type=template&id=3d2d9918&"
import script from "./online-portal-login-header.vue?vue&type=script&lang=ts&"
export * from "./online-portal-login-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports